"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleQueryFilters = exports.GetScheduleTasksFilters = exports.ScheduleReorderInput = exports.ScheduleEntryListingResponse = exports.ScheduleEntryUpdateInput = exports.ScheduleEntryCreateInput = exports.SubtaskInput = exports.ScheduleEntryTransport = exports.TaskFailure = exports.ScheduleEntrySubtask = exports.DriverTaskStatusLabels = exports.DriverTaskStatus = exports.DriverTaskStatuses = exports.DriverTaskTypeResolvedLabels = exports.DriverTaskTypeLabels = exports.DriverTaskType = exports.DriverTaskTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const order_transport_1 = require("./order-transport");
exports.DriverTaskTypes = [
    'PICKUP',
    'DELIVERY',
    'RELOCATION',
    'SWAP',
    'DUMP_AND_RETURN',
    'LIVE_LOAD',
    'TRANSPORTATION',
    'DUMP',
];
exports.DriverTaskType = typebox_1.Type.Union(exports.DriverTaskTypes.map((type) => typebox_1.Type.Literal(type)));
exports.DriverTaskTypeLabels = {
    PICKUP: 'Pickup',
    DELIVERY: 'Delivery',
    RELOCATION: 'Relocation',
    SWAP: 'Swap',
    DUMP_AND_RETURN: 'Dump and Return',
    LIVE_LOAD: 'Live Load',
    TRANSPORTATION: 'Transportation',
    DUMP: 'Dump',
};
exports.DriverTaskTypeResolvedLabels = {
    PICKUP: 'picked up',
    DELIVERY: 'delivered',
    RELOCATION: 'relocated',
    SWAP: 'swapped',
    DUMP_AND_RETURN: 'dumped and returned',
    LIVE_LOAD: 'live loaded',
    TRANSPORTATION: 'transported',
    DUMP: 'dumped',
};
exports.DriverTaskStatuses = [
    'UNASSIGNED',
    'ASSIGNED_TO_DRIVER',
    'CANCELLED',
    'FAILED',
    'COMPLETED',
    'IN_PROGRESS',
    'INCOMPLETE',
];
exports.DriverTaskStatus = typebox_1.Type.Union(exports.DriverTaskStatuses.map((status) => typebox_1.Type.Literal(status)));
exports.DriverTaskStatusLabels = {
    UNASSIGNED: 'Unassigned',
    ASSIGNED_TO_DRIVER: 'Assigned to Driver',
    CANCELLED: 'Cancelled',
    FAILED: 'Failed',
    COMPLETED: 'Completed',
    IN_PROGRESS: 'In Progress',
    INCOMPLETE: 'Incomplete',
};
exports.ScheduleEntrySubtask = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    type: exports.DriverTaskType,
    status: exports.DriverTaskStatus,
    orderID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    order: typebox_1.Type.Optional(order_transport_1.OrderTransport),
    orderSnapshot: typebox_1.Type.Optional(typebox_1.Type.Partial(order_transport_1.OrderTransport)),
    date: typebox_1.Type.Optional(typebox_1.Type.String()),
    closedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    ordinal: typebox_1.Type.Integer(),
});
exports.TaskFailure = typebox_1.Type.Object({
    reason: typebox_1.Type.Optional(typebox_1.Type.String()),
    images: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
});
exports.ScheduleEntryTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    type: exports.DriverTaskType,
    status: typebox_1.Type.Optional(exports.DriverTaskStatus),
    orderID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    order: typebox_1.Type.Optional(order_transport_1.OrderTransport),
    orderSnapshot: typebox_1.Type.Optional(order_transport_1.OrderTransport),
    date: typebox_1.Type.Optional(typebox_1.Type.String()),
    closedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    ordinal: typebox_1.Type.Integer(),
    subtaskFor: typebox_1.Type.Optional(exports.ScheduleEntrySubtask),
    subtasks: typebox_1.Type.Optional(typebox_1.Type.Array(exports.ScheduleEntrySubtask)),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    failure: typebox_1.Type.Optional(exports.TaskFailure),
});
exports.SubtaskInput = typebox_1.Type.Object({
    type: typebox_1.Type.String(),
    date: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.ScheduleEntryCreateInput = typebox_1.Type.Object({
    type: exports.DriverTaskType,
    orderID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    orderSnapshot: typebox_1.Type.Optional(order_transport_1.OrderTransport),
    date: typebox_1.Type.Optional(typebox_1.Type.String()),
    subtasks: typebox_1.Type.Optional(typebox_1.Type.Array(exports.SubtaskInput)),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.ScheduleEntryUpdateInput = typebox_1.Type.Object({
    status: typebox_1.Type.Optional(exports.DriverTaskStatus),
    orderID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    orderSnapshot: typebox_1.Type.Optional(order_transport_1.OrderTransport),
    date: typebox_1.Type.Optional(typebox_1.Type.String()),
    closedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    failure: typebox_1.Type.Optional(exports.TaskFailure),
});
exports.ScheduleEntryListingResponse = typebox_1.Type.Object({
    results: typebox_1.Type.Array(exports.ScheduleEntryTransport),
    total: typebox_1.Type.Number({ format: 'integer' }),
    offset: typebox_1.Type.Number({ format: 'integer' }),
    thisBatch: typebox_1.Type.Number({ format: 'integer' }),
});
exports.ScheduleReorderInput = typebox_1.Type.Object({
    scheduleEntryIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    driverID: typebox_1.Type.String({ format: 'uuid' }),
    date: typebox_1.Type.String(),
});
exports.GetScheduleTasksFilters = typebox_1.Type.Object({
    orderID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    status: typebox_1.Type.Optional(exports.DriverTaskStatus),
    type: typebox_1.Type.Optional(exports.DriverTaskType),
    dateBefore: typebox_1.Type.Optional(typebox_1.Type.String()),
    dateAfter: typebox_1.Type.Optional(typebox_1.Type.String()),
    sortBy: typebox_1.Type.Optional(typebox_1.Type.String()),
    sortOrder: typebox_1.Type.Optional(typebox_1.Type.String()),
    driverID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    limit: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    offset: typebox_1.Type.Optional(typebox_1.Type.Integer()),
});
exports.ScheduleQueryFilters = typebox_1.Type.Object({
    containsTaskWithOrderID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
});
//# sourceMappingURL=schedule-entry-transport.js.map